export default __webpack_public_path__ + "static/media/CS_165.5da31778.png";